import { render, staticRenderFns } from "./payFeeDiscount.vue?vue&type=template&id=35a34ce6&scoped=true"
import script from "./payFeeDiscount.vue?vue&type=script&lang=js"
export * from "./payFeeDiscount.vue?vue&type=script&lang=js"
import style0 from "./payFeeDiscount.vue?vue&type=style&index=0&id=35a34ce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a34ce6",
  null
  
)

export default component.exports